import React from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { EventPrize, EventDrawPeriod } from 'bff/models/promotion';

const ActivityInfo: React.FC<IProps> = (props) => {
  // /**
  //  * @description 產生 活動資訊 區塊
  // */
  // const handleCreateDescArea = (promoInfoContent: PromoInfoContent[]) => {
  //   const descInfos = _.filter(promoInfoContent, (content: PromoInfoContent) => content.type === PromotionInfoType.Desc);
  //   if (descInfos.length === 0) return;
  //   return _.map(descInfos, (descInfo: PromoInfoContent, index: number) =>
  //     _.map(descInfo.text, (info: string, infoIndex: number) => <p className="activity-info__desc" key={infoIndex}>{info}</p>)
  //   );
  // };
  // console.log('props', props);

  /**
   * @description 取得顯示月、季抽獎區塊
  */
  const handleCreatePrizeArea = (promoInfoContents: EventPrize[]) => {
    const res = _.map(promoInfoContents, (content:EventPrize, contentIndex:number) => {
      return (
        <div className="activity-info__item" key={contentIndex}>
          <div className="activity-info__item-title">{content.TITLE}</div>
          <ol>
            {
              _.map(content.DATA, (monthlyInfo: string, index: number) =>
                <li key={index}>{monthlyInfo}</li>)
            }
          </ol>
        </div>
      );
    });

    return res;
  };

  /**
   * @description 建立 投保期間 抽獎日期 區塊
  */
  const handleCreateSchedule = (scheduleInfos: EventDrawPeriod[]) => {
    return _.map(scheduleInfos, (scheduleInfo: EventDrawPeriod, index: number) => {
      return (
        <tr key={index}>
          <td>{scheduleInfo.PERIOD}</td>
          <td>{scheduleInfo.DRAW_DATE}</td>
        </tr>
      );
    });
  };

  return (
    <div className="activity-info">
      <div className="template-container">
        <div className="template-content">
          <div className="activity-info__title-section">
            <div className="activity-info__title">活動資訊</div>
          </div>
          <p className="activity-info__desc">{props.EVENT_DESC}</p>
          {
            props.EVENT_PRIZE && props.EVENT_PRIZE.length > 0 && handleCreatePrizeArea(props.EVENT_PRIZE)
          }
          {
            props.EVENT_DRAW_PERIOD && props.EVENT_DRAW_PERIOD.length > 0 && (
              <div className="activity-info__item">
                <table>
                  <tbody>
                    <tr>
                      <th>投保期間</th>
                      <th>抽獎日期</th>
                    </tr>
                    {handleCreateSchedule(props.EVENT_DRAW_PERIOD)}
                  </tbody>
                </table>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ActivityInfo;
